import { SSR_SESSION_TOKEN_DOM } from '@lentau/core/api/application/ssr-session-token/dom-ssr-session-token.const';
import { PageType } from '@lentau/ui-kit/core/enums/page-type.enum';
import { UserAuthorizeType } from '@lentau/auth/shared/enums';
import { DeliveryMode } from '@lentau/delivery-mode/shared/enums';
import { EnvironmentBrand, IASFeedOrganizationData } from '@lentau/ui-kit/core/environments/environments.interface';
import {
  BrandsAssets,
  LoyaltyTitle,
  RetailBrands,
  CDNBrands,
  USER_AGREEMENT_ID_ENUM,
  PERSONAL_DATA_ID_ENUM,
  PERSONAL_ACCEPT_ID_ENUM,
  FAQ_ID_ENUM,
  FAQ_ID_ENUM_B2B,
  REFERRAL_ID_ENUM,
  RECCOMENDATION_DATA_ENUM,
  DELETE_ACCOUNT_ID_ENUM,
  ADMON_OFFER_ALIAS,
  LOYALTY_PROGRAM_ID_ENUM,
  ADVERTISEMENT_AGREEMENT_ID_ENUM,
  THIRD_PARTIES_LIST_ID_ENUM,
  COOKIE_ID_ENUM,
} from '@lentau/ui-kit/core/tokens/constants';

const feeds: IASFeedOrganizationData = {
  [UserAuthorizeType.B2C]: {
    [DeliveryMode.Delivery]: {
      [PageType.Main]: null,
      [PageType.Profile]: null,
    },
    [DeliveryMode.Pickup]: {
      [PageType.Main]: null,
      [PageType.Profile]: null,
    },
    [DeliveryMode.Shop]: {
      [PageType.Main]: null,
      [PageType.Profile]: null,
    },
  },
  [UserAuthorizeType.B2B]: null,
};

export const environmentBrand: EnvironmentBrand = {
  GTM_TAG_ID: 'GTM-P5XR6889',
  RETAIL_BRAND: BrandsAssets.DOM,
  LOYALTY_TITLE: LoyaltyTitle.DOM,
  withCityDomain: true,
  CUSTOM_FEED: feeds,
  IN_APP_HOST_NAME: 'lentochka://',
  BRAND: RetailBrands.DOM,
  CDN: CDNBrands.DOM,
  INFO: {
    USER_AGREEMENT_ID: USER_AGREEMENT_ID_ENUM.DOM,
    PERSONAL_DATA_ID: PERSONAL_DATA_ID_ENUM.DOM,
    PERSONAL_ACCEPT_ID: PERSONAL_ACCEPT_ID_ENUM.DOM,
    PERSONAL_ACCEPT_URL: 'https://domlenta.ru/landings/soglasiye-na-obrabotku-personalnykh-dannykh/',
    FAQ_ID: FAQ_ID_ENUM.DOM,
    FAQ_ID_B2B: FAQ_ID_ENUM_B2B.DOM,
    REFERRAL_ID: REFERRAL_ID_ENUM.DOM,
    LEGAL_INFO_RECOMMENDATION_ID: RECCOMENDATION_DATA_ENUM.DOM,
    DELETE_ACCOUNT_ID: DELETE_ACCOUNT_ID_ENUM.DOM,
    LOYALTY_PROGRAM_ID: LOYALTY_PROGRAM_ID_ENUM.DOM,
    ADVERTISEMENT_AGREEMENT_ID: ADVERTISEMENT_AGREEMENT_ID_ENUM.DOM,
    THIRD_PARTIES_LIST_ID: THIRD_PARTIES_LIST_ID_ENUM.DOM,
    COOKIE_ID: COOKIE_ID_ENUM.DOM,
  },
  ADMON: {
    OFFER_ALIAS: ADMON_OFFER_ALIAS.DOM,
  },
  SEARCH_PLACEHOLDER: 'Найти товары',
  HAS_PICKUP: true,
  HAS_ADDRESS_MISSION: false,
  COLORS: {
    PRIMARY: '#f86800ff',
  },
  SSR_SESSION_TOKEN: SSR_SESSION_TOKEN_DOM,
};
